<template>
  <div class="page">
    <a-card :bordered="false" :headStyle="{borderBottom:'0px'}" :bodyStyle="{paddingTop:'0px'}">
      <a-row slot="title" type="flex" justify="space-between">
        <a-col :span="8">
          <span class="card-title">频道轮播图</span>
        </a-col>
        <a-col :span="8" class="text-right">
          <a-button type="primary" @click="addPro(5)">添 加</a-button>
        </a-col>
      </a-row>
      <a-table
        :columns="columns"
        rowKey="proId"
        :dataSource="bannerProList" :pagination="false">
        <div class="image-table" slot="imageSlots" slot-scope="text">
          <CustomImage :imageUrl="text" :width="120"></CustomImage>
        </div>
        <div slot="uploadImg" slot-scope="text,record">
          <a-upload
            :showUploadList="false"
            :action="uploadFileUrl"
            @change="handleChange"
            :before-upload="handleBeforeUploadImage"
          >
            <a @click="getProId(record.proId)">上传</a>
          </a-upload>
          <a-divider type="vertical"/>
          <a @click="deleteProImg(record.proId)">移除</a>
        </div>
        <div slot="typeSlots" slot-scope="text">{{ text | productTypeName }}</div>
        <div slot="action" slot-scope="text,record">
          <a-popconfirm
            title="是否要删除当前商品？"
            @confirm="deleteEvent(5,record.proId)">
            <a-icon slot="icon" type="close-circle" style="color: red"/>
            <a>移除商品</a>
          </a-popconfirm>
        </div>
      </a-table>
    </a-card>
  </div>
</template>

<script>
export default {
  name: 'BannerProHot',
  props: {
    bannerProList: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
      catalogId: this.$route.query.catalogId,//商品类型
      merchantId: this.$store.getters.userInfo.merchantId,
      uploadFileUrl: this.getUploadFileUrl(),
      imageUrl: '',
      columns: [
        {
          title: '商品ID',
          dataIndex: 'proId'
        },
        {
          title: '轮播图片',
          dataIndex: 'homeImage',
          scopedSlots: { customRender: 'imageSlots' },
          width: '120px'
        },
        {
          title: '图片上传',
          dataIndex: 'uploadImg',
          width: '110px',
          scopedSlots: { customRender: 'uploadImg' }
        },
        {
          title: '商品名称',
          dataIndex: 'proName'
        },
        {
          title: '商品类型',
          dataIndex: 'proCatalogId',
          scopedSlots: { customRender: 'typeSlots' },
          width: '120px'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '120px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ]
    }
  },
  mounted() {

  },
  methods: {
    //获取图片上传地址
    getUploadFileUrl() {
      let appConfig = this.getAppConfig()
      return appConfig.baseUrl + (appConfig.isDev ? '/' : '') + 'base/upload'
    },
    // 删除
    deleteEvent(modularClassId, proId) {
      let data = new Object()
      data.modularClassId = modularClassId
      data.proId = proId
      this.getLogUtils().logWithTag('deleteEvent', data)
      this.$emit('deletePro', data)
    },
    // 添加商品
    addPro(modularClassId) {
      this.$emit('change', modularClassId)
    },
    getProId(id) {
      this.getLogUtils().logWithTag('getProId', id)
      this.imageProId = id
    },
    // 图片上传
    handleChange(info) {
      this.getLogUtils().logWithTag('handleBeforeUploadImage', info)
      if (info.file.status === 'uploading') {
        return
      }
      if (info.file.status === 'done') {
        // Get this url from response in real world.
        if (info.file.response.status == 1) {
          this.$message.success('图片上传成功')
          this.imageUrl = info.file.response.data
          this.homeProductImg()
        } else {
          this.$message.error(info.file.response.msg)
        }
      } else if (status === 'error') {
        this.$message.error(`${info.file.name} 文件上传失败`)
      }
    },
    handleBeforeUploadImage(file) {
      this.getLogUtils().logWithTag('handleBeforeUploadImage', file)
      // 限制图片 格式、size、分辨率
      const isJPG = file.type === 'image/jpeg'
      const isJPEG = file.type === 'image/jpeg'
      const isGIF = file.type === 'image/gif'
      const isPNG = file.type === 'image/png'
      if (!(isJPG || isJPEG || isGIF || isPNG)) {
        this.$message.error('上传图片的格式不正确，不是JPG、JPEG、GIF、PNG')
        return false
      }
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isLt2M) {
        this.$message.error('上传的文件不能大于2M!')
      }
      return true
    },
    homeProductImg() {
      let params = new Object()
      params.img = this.imageUrl
      params.merchantId = this.merchantId
      params.modularClassId = 5
      params.proId = this.imageProId
      params.proType = this.catalogId
      params.type = 1
      this.getLogUtils().logWithTag('homeProductImg', params)
      this.$emit('updateImage', params)
    },
    deleteProImg(proId) {
      this.imageUrl = ''
      let params = new Object()
      params.img = ''
      params.merchantId = this.merchantId
      params.modularClassId = 5
      params.proId = proId
      params.proType = this.catalogId
      params.type = 0//0是删除
      this.getLogUtils().logWithTag('deleteProImg', params)
      this.$emit('updateImage', params)
    }
  }

}
</script>
<style lang="less" scoped>
@import url('../../CustomPage.less');

.card-title {
  padding-left: 10px;
  border-left: 1px solid #FAAD14;
  line-height: 32px;
  margin-right: 5px;
}

.text-right {
  text-align: right;
}
</style>